import React, { useState, useEffect, useRef } from "react";
import { Box, Grid, Button, Typography } from "@mui/material";
import Navbar from "../components/Navbar";
import logoImage from "../Images/tw logo.svg"; // Replace with your logo image path
import earth from "../Images/earth.jpg"; // Replace with your background image path
import "typeface-raleway";

const Page1 = ({ onJoinClick, onLogoClick }) => {
  // Typing Effect State and Logic
  const words = ["Optimize", "Save", "Sustain"];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const word = words[currentWordIndex];
    let typingSpeed = 200;

    const timeout = setTimeout(() => {
      if (isDeleting) {
        setCurrentText((prev) => prev.slice(0, prev.length - 1));
        typingSpeed = 50;
      } else {
        setCurrentText((prev) => word.substring(0, prev.length + 1));
      }

      if (!isDeleting && currentText === word) {
        setTimeout(() => setIsDeleting(true), 1500);
      } else if (isDeleting && currentText === "") {
        setIsDeleting(false);
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, currentWordIndex, words]);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        maxWidth: "100%", 
        margin: "0 auto", 
        backgroundImage: `url(${earth})`,
        backgroundSize: "cover",
        backgroundPosition: "52.5% center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
        
      }}
    >
     {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "#2f2f2f",
          opacity: 0.2, 
          zIndex: 1,
        }}
      />
        <Box
       sx={{
        position: "absolute",
        top: -10,
        left: 0,
        right: 0,
        height: "507px", 
        background: "linear-gradient(to bottom, black, transparent)", 
        zIndex: 2, 
    }}
/>
<Box
       sx={{
        position: "absolute",
        bottom: -5,
        left: 0,
        right: 0,
        height: "507px", 
        background: "linear-gradient(to top, black, transparent)", 
        zIndex: 2, 
    }}
/>

      {/* Navbar */}
      <Navbar 
        onLogoClick={onLogoClick} 
        onJoinClick={onJoinClick} 
        isMobile={true} 
      />

      

      {/* Main Content */}
      <Box
        sx={{
          marginTop: "80px", 
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          flexGrow: 1, 
          zIndex: 4,
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: "60px",
            color: "#fff",
            textShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
            marginBottom: "10px",
            height: "50px", 
            display: "flex",
            alignItems: "center",
            fontFamily: "Raleway, sans-serif",
            fontWeight: "bold",	
          }}
        >
          {currentText}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "25px",
            color: "#00d8ff",
            textShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
            fontFamily: "Raleway, sans-serif",
            fontWeight: "regular",
          }}
        >
          All you want in one place
        </Typography>
      </Box>
    </Box>
  );
};

export default Page1;
